module.exports = __webpack_public_path__ + "img/logo.80e82789.svg";